import {
  commonSelectors,
  createQcsThunks,
  createResourceEntityAdapter,
} from 'app-components/flux/core/resourceSliceUtils';

import { getLogger } from 'app-components/utils/core';
import { createAppSlice } from 'app-components/utils/redux-store/createAppSlice';

import aiMemoriesApi from './aiMemoriesApi';
import type { AiMemoriesState, AiMemoriesStorageData } from './aiMemoriesTypes';
import { AI_MEMORIES_REDUCER_KEY } from './aiMemoriesTypes';

const log = getLogger('data/ai-memories/aiMemoriesSlice.ts');

// Define the initial empty state.
// when we dispatch aiMemoriesActions.fetch().
const initialState: AiMemoriesState = {
  entities: {},
  ids: [],
  isLoading: false,
  loadPending: true,
  error: null,
  lastSyncDate: null,
};

// Create an entity adapter for handling a single AiMemoriesStorageData resource.
const entityAdapter = createResourceEntityAdapter<AiMemoriesStorageData>();
const entitySelectors = entityAdapter.getSelectors();

// Create the slice using createAppSlice utility function
export const slice = createAppSlice({
  name: AI_MEMORIES_REDUCER_KEY, // Name of the slice
  initialState: entityAdapter.getInitialState(initialState), // Initial state with entity adapter
  reducers: (create) =>
    createQcsThunks({
      create,
      refetch(dispatch) {
        // If a refetch is needed, simply call fetch again.
        dispatch(slice.actions.fetch());
      },
      api: aiMemoriesApi, // API for retirement planner
      adapter: entityAdapter, // Entity adapter for handling resources
      log, // Logger instance
    }),
  selectors: {
    ...entitySelectors, // Entity selectors
    ...commonSelectors, // Common selectors
  },
});

// Export actions and selectors for the retirement planner slice
export const aiMemoriesActions = slice.actions;
export const aiMemoriesSelectors = slice.selectors;
export { slice as aiMemoriesSlice };

// Export the reducer as the default export
export default slice.reducer;
